import React from 'react';
import { CalendarDaySC } from './calendar-day.styled';
import BackgroundGrid from '../calendar-week/components/background-grid';

type CalendarDayProps = {};

const CalendarDay: React.FunctionComponent<CalendarDayProps> = () => {
  return (
    <CalendarDaySC className={'calendar-day'}>
      <BackgroundGrid minHour={0} maxHour={24} style={{}} showDayProgress={false} />
    </CalendarDaySC>
  );
};

export default CalendarDay;
